<template>
  <div>
    <v-app v-if="applidationLoaded" id="app">
      <Header v-model="drawer" :collapsed="collapsed" />
      <Sidebar v-model="drawer" />
      <v-main>
        <v-container class="page-container" fluid fill-height>
          <router-view :key="$route.name" />
        </v-container>
      </v-main>
      <Footer />
      <Alert />
      <AuthModal />
    </v-app>
    <div v-else>
      <Spinner />
    </div>
  </div>
</template>

<script>
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default {
  name: "DefaultLayout",
  components: { Header, Footer },

  data() {
    return {
      drawer: false,
      collapsed: window.pageYOffset > 50,
    };
  },
  created() {
    this.initApplication();

    document.body.onscroll = () => {
      this.collapsed = window.pageYOffset > 50;
    };
  },
  methods: {
    async initApplication() {
      await this.$store.dispatch("application/init");
      this.initPage();
    },
    initPage() {
      const pageSlug = this.$route.query.page;
      if (pageSlug) {
        const page = this.$store.getters["page/list"].find(
          (s) => s.slug == pageSlug
        );
        if (page) this.$store.commit("page/setActive", page);
      }
    },
  },
  computed: {
    routerKey() {
      return this.activePage?.id || 0;
    },
  },
};
</script>

<style scoped lang="scss">
#app {
  margin: auto;
  position: relative;

  .v-main {
    overflow: hidden;
  }
}
.page-container {
  display: block !important;
  padding: 0;
  overflow: hidden;
  margin-bottom: 40px;
}
</style>
